export const ANALYSIS_COLUMN_KEYS = {
  requester: 'requerente',
  sampleNumber: 'numero_amostra',
  species: 'especie',
  entryDate: 'data_entrada',
  analysisDate: 'data_analise',
  cultivar: 'cultivar',
  shipmentNumber: 'numero_remessa',
  determination: 'determinacao',
  treatment: 'tratamento',
  status: 'status',
  progress: 'progresso',
  firstSample: 'amostra1',
  secondSample: 'amostra2',
  average: 'media',
  action: 'acao',
} as const;

export type AnalysisColumnKey = (typeof ANALYSIS_COLUMN_KEYS)[keyof typeof ANALYSIS_COLUMN_KEYS];

export const ANALYSIS_SORT_KEYS = [
  ANALYSIS_COLUMN_KEYS.requester,
  ANALYSIS_COLUMN_KEYS.sampleNumber,
  ANALYSIS_COLUMN_KEYS.entryDate,
  ANALYSIS_COLUMN_KEYS.species,
  ANALYSIS_COLUMN_KEYS.shipmentNumber,
  ANALYSIS_COLUMN_KEYS.determination,
  ANALYSIS_COLUMN_KEYS.analysisDate,
  ANALYSIS_COLUMN_KEYS.status,
] as const;

export type AnalysisSortKey = (typeof ANALYSIS_SORT_KEYS)[number];
